import injector from 'vue-inject'
import store from './store'
import IndexPage from './pages/index'
import CreateNewStorePage from './pages/create-new-store'
import SignInProcessingPage from './pages/sign-in-processing'
import DashboardPage from './pages/dashboard'
import ManagementPage from './pages/management'
import MenuListPage from './pages/menu-list'
import MenuTimeSettings from './pages/menu-time-settings'
import MenuTimeSelectionSheet from './pages/modals/menu-time-selection-sheet'
import MenuDraftActions from './pages/modals/menu-draft-actions'
import MenuDraftEditMainPage from './pages/menu-draft/edit-main'
import MenuDraftCopyPage from './pages/menu-draft/copy-draft'
import MenuDraftReleasePage from './pages/menu-draft/release'
import MenuDraftSettingsPage from './pages/menu-draft/settings'
import MenuDraftCategoriesPage from './pages/menu-draft/categories'
import MenuDraftEditItemPage from './pages/menu-draft/item'
import MenuDraftEditItemQuestionsPage from './pages/menu-draft/item-questions'
import MenuDraftEditQuestionPage from './pages/menu-draft/question'
import MenuDraftEditOptionPage from './pages/menu-draft/option'
import MenuDraftEditImagePage from './pages/menu-draft/image'
import ManageAllItemsPage from './pages/manage-all-items'
import StatisticsPage from './pages/statistics'
import StatisticsSearchPage from './pages/statistics-search'
import HotSaleSearchPage from './pages/hot-sale-search'
import StatisticsSearchResultsPage from './pages/statistics-search-results'
import HotSaleSearchResultsPage from './pages/hot-sale-search-results'
import OrdersPage from './pages/orders'
import WorkStationPage from './pages/work-station'
import OrderDetailsPage from './pages/order-details'
import InfoPage from './pages/info'
import AccountPage from './pages/account'
import EditDisplayNamePrompt from './pages/prompts/edit-display-name-prompt'
import EditEmailForm from './pages/edit-email-form'
import LinkEmailAccountForm from './pages/link-email-account-form'
import AuthPage from './pages/auth'
import EmployeePage from './pages/employee'
import EmployeePermissionsPage from './pages/employee-permissions'
import UserCashiersPage from './pages/user-cashiers'
import UserMonitorsPage from './pages/user-monitors'
import SystemSettingsPage from './pages/system-settings'
import StoreInfoSettingsPage from './pages/store-info-settings'
import TableNumbersPage from './pages/table-numbers'
import BusinessHoursPage from './pages/business-hours'
import QrCodeDownloadPage from './pages/qr-code-download'
import InvoiceFailedPage from './pages/invoice-failed'
import SoldOutSettingPage from './pages/sold-out-setting'

import SpecialRequestsPopup from './pages/modals/special-requests-popup'
import RefundPopup from './pages/modals/refund-popup'
import ChangeQuestionTypeActions from './pages/menu-draft/modals/change-question-type-actions'
import QuestionDefaultValueActions from './pages/menu-draft/modals/question-default-value-actions'
import MenuDraftElementDuplicateActions from './pages/menu-draft/modals/menu-draft-element-duplicate-actions'
import ItemActions from './pages/menu-draft/modals/item-actions'
import QuestionActions from './pages/menu-draft/modals/question-actions'
import OptionActions from './pages/menu-draft/modals/option-actions'
import CreateQuestionActions from './pages/menu-draft/modals/create-question-actions'
import NotFoundPage from './pages/not-found.vue'

import PanelLeftPage from './pages/panel-left'
import PanelRightPage from './pages/panel-right'

const withSignedIn = param => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.userModule.signInStatus === injector.get('userSignInStatusType').processing) {
    reject()
    this.navigate(`/sign-in-processing?r=${routeTo.url}`)
  } else if (store.state.userModule.signInStatus === injector.get('userSignInStatusType').signedIn) {
    if (typeof param === 'function') {
      param.call(this, routeTo, routeFrom, resolve, reject)
    } else {
      resolve(param)
    }
  } else {
    reject()
    this.navigate(`/auth${routeTo.url ? `?r=${routeTo.url}` : ''}`)
  }
}

const withInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    if (routeFrom.path.endsWith('/panel-right-open') || routeFrom.path.endsWith('/panel-left-open')) {
      this.app.panel.right.close()
      resolve(component, { reloadCurrent: true })
    } else {
      resolve(component)
    }
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdPathProp}/dashboard`, { reloadAll: true })
  }
}

const withBusinessHoursInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    resolve(component)
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdProp}/business-hours`, { reloadAll: true })
  }
}

const withEmployeeInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    resolve(component)
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdProp}/employee`, { reloadAll: true })
  }
}

const withStatisticsInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    resolve(component)
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdProp}/statistics`, {
      reloadAll: true
    })
  }
}

const withMenuDraftInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    resolve(component)
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdProp}/menu-list`, { reloadAll: true })
  }
}

const withOrdersInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.state.store) {
    resolve(component)
  } else {
    reject()
    this.navigate(`/stores/${routeTo.params.storeIdProp}/orders`, { reloadAll: true })
  }
}

export default [{
  path: '/',
  async: withSignedIn({ component: IndexPage })
}, {
  path: '/create-new-store',
  component: CreateNewStorePage
}, {
  path: '/sign-in-processing',
  component: SignInProcessingPage
}, {
  path: '/stores/:storeIdProp/dashboard',
  async: withSignedIn({ component: DashboardPage })
}, {
  path: '/panel-left',
  component: PanelLeftPage
}, {
  path: '/panel-right',
  component: PanelRightPage
}, {
  path: '/stores/:storeIdProp/management',
  async: withSignedIn({ component: ManagementPage })
}, {
  path: '/stores/:storeIdProp/statistics',
  async: withSignedIn({ component: StatisticsPage })
}, {
  path: '/stores/:storeIdProp/statistics-search',
  async: withSignedIn(withStatisticsInit({ component: StatisticsSearchPage }))
}, {
  path: '/stores/:storeIdProp/hot-sale-search',
  async: withSignedIn(withStatisticsInit({ component: HotSaleSearchPage }))
}, {
  path: '/stores/:storeIdProp/statistics-search-results',
  async: withSignedIn(withStatisticsInit({ component: StatisticsSearchResultsPage }))
}, {
  path: '/stores/:storeIdProp/hot-sale-search-results',
  async: withSignedIn(withStatisticsInit({ component: HotSaleSearchResultsPage }))
}, {
  path: '/stores/:storeIdProp/manage-all-items',
  async: withSignedIn({ component: ManageAllItemsPage })
}, {
  path: '/stores/:storeIdProp/menu-list',
  async: withSignedIn({ component: MenuListPage })
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/settings',
  async: withSignedIn({ component: MenuDraftSettingsPage })
}, {
  path: '/stores/:storeIdProp/menu-time-settings/:menuVariationProp',
  async: withSignedIn(withBusinessHoursInit({ component: MenuTimeSettings }))
}, {
  path: '/stores/:storeIdProp/menus/:menuVariationProp/menu-time-selection/:timeIndices',
  async: withSignedIn({ sheet: { component: MenuTimeSelectionSheet } })
}, {
  path: '/stores/:storeIdProp/menus/:menuVariationProp/:menuVersionProp/sold-out-setting',
  async: withSignedIn(withMenuDraftInit({ component: SoldOutSettingPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/menu-draft-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: MenuDraftActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/duplicate-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: MenuDraftElementDuplicateActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/edit-main',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditMainPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/copy',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftCopyPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/release',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftReleasePage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/categories',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftCategoriesPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/edit-item',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditItemPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/edit-item-question',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditItemQuestionsPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/items/:itemIdProp/item-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: ItemActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/questions/:questionIdProp/question-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: QuestionActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/options/:optionIdProp/option-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: OptionActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/create-question-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: CreateQuestionActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/questions/:questionIdProp/change-question-type-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: ChangeQuestionTypeActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/questions/:questionIdProp/question-default-value-actions',
  async: withSignedIn(withMenuDraftInit({ actions: { component: QuestionDefaultValueActions } }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/edit-question',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditQuestionPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/edit-option',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditOptionPage }))
}, {
  path: '/stores/:storeIdProp/menu-drafts/:menuDraftVariationProp/items/:itemIdProp/image',
  async: withSignedIn(withMenuDraftInit({ component: MenuDraftEditImagePage }))
}, {
  path: '/stores/:storeIdProp/orders',
  async: withSignedIn({ component: OrdersPage })
}, {
  path: '/stores/:storeIdProp/work-station',
  async: withSignedIn({ component: WorkStationPage })
}, {
  path: '/stores/:storeIdProp/order-details/:orderPublicIdProp',
  async: withSignedIn(withOrdersInit({ component: OrderDetailsPage }))
}, {
  path: '/stores/:storeIdProp/order-details/:orderIdProp/items/:itemIdProp/special-requests-popup',
  async: withSignedIn(withOrdersInit({ popup: { component: SpecialRequestsPopup } }))
}, {
  path: '/stores/:storeIdProp/orders/:orderIdProp/refund',
  async: withSignedIn(withInit({ popup: { component: RefundPopup } }))
}, {
  path: '/info',
  component: InfoPage
}, {
  path: '/user-cashiers',
  async: withSignedIn({ component: UserCashiersPage })
}, {
  path: '/user-monitors',
  async: withSignedIn({ component: UserMonitorsPage })
}, {
  path: '/account',
  async: withSignedIn({ component: AccountPage })
}, {
  path: '/edit-display-name-prompt',
  async: withSignedIn({ popover: { component: EditDisplayNamePrompt } })
}, {
  path: '/edit-email-form',
  async: withSignedIn({ component: EditEmailForm })
}, {
  path: '/link-email-account-form',
  async: withSignedIn({ component: LinkEmailAccountForm })
}, {
  path: '/system-settings',
  async: withSignedIn({ component: SystemSettingsPage })
}, {
  path: '/stores/:storeIdProp/store-info-settings',
  async: withSignedIn({ component: StoreInfoSettingsPage })
}, {
  path: '/stores/:storeIdProp/store-info-settings/table-numbers',
  async: withSignedIn({ component: TableNumbersPage })
}, {
  path: '/stores/:storeIdProp/business-hours',
  async: withSignedIn({ component: BusinessHoursPage })
}, {
  path: '/stores/:storeIdProp/qr-code-download',
  async: withSignedIn({ component: QrCodeDownloadPage })
}, {
  path: '/stores/:storeIdProp/invoice-failed',
  async: withSignedIn({ component: InvoiceFailedPage })
}, {
  path: '/auth',
  component: AuthPage
}, {
  path: '/stores/:storeIdProp/employee',
  async: withSignedIn({ component: EmployeePage })
}, {
  path: '/stores/:storeIdProp/employee-permissions/:uid',
  async: withSignedIn(withEmployeeInit({ component: EmployeePermissionsPage }))
}, {
  path: '(.*)',
  component: NotFoundPage
}]
